import { RentalHistoryAddressAddedActivity } from "../types";
import { combinedRoles } from "../constants";
import { getFullName } from "shared/utils/get-full-name";

export const RentalHistoryAddressAdded = ({
  activityItem
}: {
  activityItem: RentalHistoryAddressAddedActivity;
}) => {
  const authorRole = activityItem.author?.author_role;

  const contact = activityItem.details?.contact;
  const contactName = getFullName({
    firstName: contact?.first_name || "",
    lastName: contact?.last_name || "",
    middleName: contact?.middle_name,
    short: true
  });
  const contactRole = contact?.role ? combinedRoles[contact.role] : "";

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        New rental history address was added
      </p>
      <p className="text-sm font-normal text-content-400">
        {activityItem.author?.name ? `by ${activityItem.author?.name}` : ""}
        {authorRole ? ` (${combinedRoles[authorRole] || authorRole})` : ""}
        {contactName ? ` for ${contactName}` : ""}
        {contactRole ? ` (${contactRole})` : ""}
      </p>
    </div>
  );
};
